import { ModalAction, ModalState } from 'modules/linkExpirationManagement/types';
import { Dispatch, SetStateAction } from 'react';
import { useModalContext } from 'utils/contexts/modal';
import { CopyAllModal } from './CopyAllModal';
import { UnsavedChangesModal } from './UnsavedChangesModal';

type ModalsProps = {
  setShouldNavigate: Dispatch<SetStateAction<boolean>>;
};

export const Modals = ({ setShouldNavigate }: ModalsProps) => {
  const { hideModal, modalState } = useModalContext<ModalState>();

  const { action = null } = modalState || {};

  switch (action) {
    case ModalAction.COPY_ALL:
      return modalState?.payload?.setting && <CopyAllModal onClose={hideModal} />;
    case ModalAction.UNSAVED_CHANGES:
      return <UnsavedChangesModal onClose={hideModal} setShouldNavigate={setShouldNavigate} />;
    default:
      return null;
  }
};
